<template>
    <va-create-layout>
        <FinancialOrder-form :title="title" :item="item"></FinancialOrder-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
